import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useErrorContext } from './../../components/messages/ErrorBox';
import { usePageLoadingContext } from './../../components/messages/PageLoading';
import { useLocale } from './../../components/special/LanguageProvider';
import { apiGetCall, apiPostCall, isResultOk } from './../../components/special/apiCall';
import  EditForm  from 'components/form/EditForm';
import  EditFormFieldTable  from 'components/form/EditFormFieldTable';
import InputDate from './../../components/input/InputDate';
import InputDropDownList from './../../components/input/InputDropDownList';
import ListTable from './../../components/form/ListTable';
import TextDate from './../../components/text/TextDate';
import  TextAmount  from 'components/text/TextAmount';
import InputNumber from './../../components/input/InputNumber';


const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const FormEdit = ({history}) => {
  
  const params = new URLSearchParams(useLocation().search);  
  const setCheckErrorItems = useErrorContext();
  const setIsPageLoading = usePageLoadingContext();
  const { t } = useLocale();

   //Init blank formdata record.
   const [formData, setFormData] = useState({        
    isNew : true        
  });  

  //Init blank working data record
  const [workingData, setWorkingData] = useState({
    actionCostID: null,
    actionID: null,
    transactionKeyID: null,
    costDate: new Date(),
    amount: 0
  });

  const [lookupData, setLookupData] = useState({        
    transactionKeyList : [],
    actionList : [],
  });


  const goBack = () => {
    history.push("/admin/actioncosts");
  }

  const loadLookupData = async() =>{
    //Load all the data at the same time.     
    let [transactionKeyList, actionList] = await Promise.all([
      apiGetCall(BASE_URL + '/admin/list/transactionkey' ),
      apiGetCall(BASE_URL + '/admin/list/action' ),
    ]);           
    //Check we need to display any critical errors.
    setCheckErrorItems([transactionKeyList, actionList]);            

    //Translate the data into what we want to use.
    setLookupData( {
      transactionKeyList : transactionKeyList,
      actionList : actionList
    });
  }


  const loadFormData = async() => {
    setIsPageLoading(true);
    let newFormData = {...formData};    
    //Read the query parameters, if we don´t have any then go back to transaction keys.
    let isNew = params.get("new");        
    if (!isNew){      
      let editID = params.get("actioncostid");    
      if (editID == null || editID <= 0){      
        goBack();
      }    
      else{
        newFormData.isNew = false;      
        let requestResult = await apiGetCall(BASE_URL + '/admin/actioncost/' + editID);       
        if (isResultOk(requestResult, setCheckErrorItems)){        
          setWorkingData(requestResult);                          
        }  
      }
    }
    
    //Lookup data.
    await loadLookupData();

    setFormData(newFormData);
    setIsPageLoading(false);
    
  }

  useEffect(() => {
    loadFormData();
  }, []);

  const onSaveClick = async() => {

    setIsPageLoading(true);
    let requestResult = null;
    if (formData.isNew){      
      console.log("Test", workingData);
      requestResult = await apiPostCall(BASE_URL + '/admin/actioncost/create', workingData);       
      console.log("res", requestResult);
    }
    else{      
      requestResult = await apiPostCall(BASE_URL + '/admin/actioncost/change', workingData);       
    }    
    if (isResultOk(requestResult, setCheckErrorItems)){          
      goBack();
    }
    setIsPageLoading(false);    
  }

  const onBackClick = () => {    
    goBack();
  }
  
  const validateInput = async () => {
    let messages = [];      

    if (workingData.actionID == null || workingData.actionID === 0){
      messages.push("Vantar að velja aðgerð");      
    }

    if (workingData.transactionKeyID == null || workingData.transactionKeyID === 0){
      messages.push("Vantar að velja færslulykil");      
    }

    if (workingData.amount <= 0){
      messages.push("Upphæð þarf að vera hærri en 0");      
    }

    return messages; 
  }

  
  return (
    <EditForm title={formData.isNew ? "Nýr fastur kostnaður" : "Uppfæra fastan kostnað"} onSubmitClick={onSaveClick} onBackClick={onBackClick} onValidate={validateInput}>
      <EditFormFieldTable fields={[
        {
          title: "Kostnaður á aðgerð",
          edit : () => <InputDropDownList
                        name="ActionID"
                        disabled={!formData.isNew}
                        list={lookupData.actionList}
                        keyField="itemID"
                        displayField = { (item) => { return item.name + " " + (item.itemID ? "("+item.itemID+")" : ""); } }
                        defaultValue = {workingData.actionID}
                        onChange={(value) => setWorkingData({ ...workingData, actionID : value})}
                        nullable={true}
                        nullableItem={{itemID: null, name: ""}}
                      />          
        },
        {
          title: formData.isNew ? "Tengja við færslulykill" : 'Tengdur færslulykill',
          edit : () => <InputDropDownList
                        name="TransactionKeyID"
                        disabled={!formData.isNew}
                        list={lookupData.transactionKeyList}
                        keyField="itemID"
                        displayField = { (item) => { return item.name + " " + (item.data ? "("+item.data.key+")" : ""); } }
                        defaultValue = {workingData.transactionKeyID}
                        onChange={(value) => setWorkingData({ ...workingData, transactionKeyID : value})}
                        nullable={true}
                        nullableItem={{itemID: null, name: ""}}
                      />          
        },  
        {
          title: "Gildir frá",
          edit : () => (<InputDate name="CostDate" value={workingData.costDate} onChange={(value) => setWorkingData({ ...workingData, costDate : value})}/>)          
        },   
        {
          title: "Upphæð",
          edit : () => (<InputNumber name="Amount" value={workingData.amount} onChange={(value) => setWorkingData({ ...workingData, amount : value})}/>)          
        },       
      ]}/>      

      <ListTable                    
          list = {workingData.costDates}
          colsettings = {['50%','50%']}
          headers = {[
            t("Kostnaður"),            
            <div className="text-right">{t("Upphæð")}</div>,                                    
          ]}
          columns = {[
            (item) => <><TextDate value={item.costDate}/>{item.isCurrent ? <span className="icon-checkmark-circle2 text-blue" data-tip="Núverandi kostnaður"></span> : null} </>,
            (item) => <div className="text-right"><TextAmount value={item.amount}/></div>,
          ]}
      />
    </EditForm>    
  );
}





